module.exports = __webpack_public_path__ + "static/media/Alexis.f7b18f0f.jpg";